/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AUSpinnerComponent from '@aarhus-university/au-lib-react-components/src/components/AUSpinnerComponent';
import FilterComponent from '../components/FilterComponent';
import VacancyComponent from '../components/VacancyComponent';
import NoResultsComponent from '../components/NoResultsComponent';
import getVacancies from '../actions/getVacancies';
import getAreas from '../actions/getAreas';
import getHours from '../actions/getHours';
import getLocations from '../actions/getLocations';
import setFilter from '../actions/setFilter';

class AppComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      updating: false,
    };

    this.setFilter = this.setFilter.bind(this);
    this.cancelUpdate = this.cancelUpdate.bind(this);
  }

  /*
  componentDidUpdate() {
    const filterButtons = document.querySelectorAll('button.filter');
    filterButtons.forEach((b) => {
      b.removeEventListener('transitionend', this.cancelUpdate);
      b.addEventListener('transitionend', this.cancelUpdate);
    });
  }
  */

  setFilter(filter) {
    const { actions } = this.props;
    this.setState({
      updating: true,
    }, () => {
      actions.setFilter(filter);
      setTimeout(() => {
        this.setState({
          updating: false,
        });
      }, 200);
    });
  }

  cancelUpdate() {
    this.setState({
      updating: false,
    });
  }

  render() {
    const {
      element,
      lang,
      totalAmount,
      filtered,
      title,
      loaded,
      actions,
      hours,
      locations,
      areas,
      sessionValid,
      phdLink,
      mode,
    } = this.props;

    const { updating } = this.state;

    const renderFiltered = filtered.map(
      (vacancy) => (
        (
          <VacancyComponent
            key={vacancy.id}
            lang={lang}
            vacancy={vacancy}
            mode={mode}
          />
        )
      ),
    );

    return [
      <FilterComponent
        key={0}
        empty={loaded && totalAmount === 0}
        lang={lang}
        title={title}
        amount={filtered.length}
        hours={hours}
        locations={locations}
        areas={areas}
        setFilter={this.setFilter}
        sessionValid={sessionValid}
        phdLink={phdLink}
        mode={mode}
      />,
      <AUSpinnerComponent
        key={1}
        loaded={loaded}
        loadingCondition={!loaded}
        onLoad={() => {
          actions.getHours(lang);
          actions.getAreas(lang);
          actions.getLocations(lang);
          actions.getVacancies(element);
        }}
      >
        {(() => {
          if (totalAmount > 0 && loaded) {
            if (filtered.length === 0) {
              return <NoResultsComponent lang={lang} mode={mode} />;
            }
            const className = `au-vacancies-list resetlist${updating ? ' updating' : ''}`;
            return (
              <ul className={className}>
                {renderFiltered}
              </ul>
            );
          }
          return null;
        })()}
      </AUSpinnerComponent>,
    ];
  }
}

AppComponent.propTypes = {
  element: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  loaded: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    getVacancies: PropTypes.func.isRequired,
    getAreas: PropTypes.func.isRequired,
    getHours: PropTypes.func.isRequired,
    getLocations: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
  }).isRequired,
  filtered: PropTypes.arrayOf(PropTypes.shape({
    area: PropTypes.number,
    deadline: PropTypes.number.isRequired,
    end: PropTypes.number,
    faculty: PropTypes.string.isRequired,
    hours: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    location: PropTypes.shape({
      name: PropTypes.string.isRequired,
      zip: PropTypes.number.isRequired,
    }).isRequired,
    mode: PropTypes.string.isRequired,
    start: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  })).isRequired,
  title: PropTypes.string.isRequired,
  areas: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })).isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })).isRequired,
  hours: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })).isRequired,
  totalAmount: PropTypes.number.isRequired,
  sessionValid: PropTypes.bool.isRequired,
  phdLink: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  // errors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

function mapStateToProps(state) {
  return state.vacancies;
}

function mapDispatchToProps(dispatch) {
  const actions = {
    getVacancies,
    getAreas,
    getHours,
    getLocations,
    setFilter,
  };

  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

AppComponent.displayName = 'AppComponent';
export default connect(mapStateToProps, mapDispatchToProps)(AppComponent);
